import Action from "../interfaces/Action";
import ActionTypeEnum from "../enums/ActionTypeEnum";
import CreateOrderResult from "../interfaces/order/CreateOrderResult";

export default function orderReducer(state: CreateOrderResult | null = null, action: Action) {
    switch (action.type) {
        case ActionTypeEnum.ORDER_RESULT_SET:
            return action.payload;
        default:
            return state;
    }
}
